import React from "react";
import "./styles/Certification.scss";
import CertificationCard from "../../components/CertificationCard";
import CustomSlider from "../../components/CustomSlider";
import { useTranslation } from "react-i18next";

const Certification = () => {
  const { t } = useTranslation();
  return (
    <>
      <div id="certification_wrap">
        <div className="left">
          <div className="title_wrap">
            <h2>{t("home.certification.title")}</h2>
            <div className="des">{t("home.certification.des")}</div>
          </div>
          <div className="card_wrap">
            <div className="card leed_card">
              <div className="upper">{t("home.certification.card1.name")}</div>
              <div className="under">
                <div className="txt_wrap">
                  <span>{t("home.certification.card1.list_1")}</span>
                  <span>{t("home.certification.card1.list_2")}</span>
                  <span>{t("home.certification.card1.list_3")}</span>
                  <span>{t("home.certification.card1.list_4")}</span>
                  <span>{t("home.certification.card1.list_5")}</span>
                </div>
                <div className="patent_icon_wrap">
                  <img src="/imgs/icon_patent.png" alt="patent" />
                </div>
              </div>
            </div>
            <div className="card human_resources_card">
              <div className="upper">{t("home.certification.card2.name")}</div>
              <div className="under">
                <div className="txt_wrap">
                  <span>{t("home.certification.card2.list_1")}</span>
                  <span>{t("home.certification.card2.list_2")}</span>
                  <span>{t("home.certification.card2.list_3")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <CustomSlider
            setting={{
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              autoplaySpeed: 3000,
              arrows: false,
              draggable: false,
            }}
            navigation={{ pagingType: "type_01", color: "#111111", position: { bottom: "0px", left: "50%", transform: "translate(-50%, -50%)" } }}
          >
            <CertificationCard
              path={[
                "/imgs/certification_01.png",
                "/imgs/certification_02.png",
                "/imgs/certification_03.png",
                "/imgs/certification_04.png",
                "/imgs/certification_05.png",
                "/imgs/certification_06.png",
                "/imgs/certification_07.png",
                "/imgs/certification_08.png",
                "/imgs/certification_09.png",
              ]}
            />
            <CertificationCard
              path={[
                "/imgs/certification_10.png",
                "/imgs/certification_11.png",
                "/imgs/certification_12.png",
                "/imgs/certification_13.png",
                "/imgs/certification_14.png",
                "/imgs/certification_15.png",
                "/imgs/certification_16.png",
                "/imgs/certification_17.png",
                "/imgs/certification_18.png",
              ]}
            />
            <CertificationCard path={["/imgs/certification_19.png", "/imgs/certification_20.png", "/imgs/certification_21.png"]} />
          </CustomSlider>
        </div>
        {/* <div className="bg_img">
          <img src="/imgs/bg_certification.png" alt="background_image_certification.png" />
        </div> */}
      </div>
    </>
  );
};

export default Certification;
